import React from 'react';

const SvgCheckboxInactive = ({ size = 13, ...props }) => (
    <svg width={size} height={size} viewBox='0 0 13 13' {...props}>
        <rect
            width={12}
            height={12}
            x={0.5}
            y={0.5}
            rx={2}
            ry={2}
            fill='#fff'
            fillRule='evenodd'
            stroke='#b2b2b2'
        />
    </svg>
);

const MemoSvgCheckboxInactive = React.memo(SvgCheckboxInactive);
export default MemoSvgCheckboxInactive;
